const DAY_MS = 24 * 3600 * 1000;

export function buildRecentDayRange(days, delayDays, now = Date.now()) {
  return [
    now - (days + delayDays - 1) * DAY_MS,
    now - delayDays * DAY_MS,
  ];
}

export function buildRecentMonthRange(months, delayDays, now = Date.now()) {
  const end = new Date(now - delayDays * DAY_MS);
  const start = new Date(end);
  const originalDay = start.getDate();
  start.setDate(1);
  start.setMonth(start.getMonth() - months);
  const lastDayOfTargetMonth = new Date(
    start.getFullYear(),
    start.getMonth() + 1,
    0,
  ).getDate();
  start.setDate(Math.min(originalDay, lastDayOfTargetMonth));
  return [start, end];
}

export function buildPreviousMonthRange(now = Date.now()) {
  const current = new Date(now);
  return [
    new Date(current.getFullYear(), current.getMonth() - 1, 1),
    new Date(current.getFullYear(), current.getMonth(), 0),
  ];
}

export function buildDateRangeShortcuts(delayDays = 2, now = Date.now()) {
  return [
    {text: '最近7天', value: buildRecentDayRange(7, delayDays, now)},
    {text: '最近30天', value: buildRecentDayRange(30, delayDays, now)},
    {text: '最近三个月', value: buildRecentMonthRange(3, delayDays, now)},
    {text: '上个月', value: buildPreviousMonthRange(now)},
  ];
}
